import React, { FC, ReactNode, useEffect, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Filter } from "../../models/Filter";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import { Lookup } from "../../models/Lookup";
import { SearchTerm } from "../../models/search/SearchTerm";
import { TableColumn } from "../../models/table/TableColumn";
import TableTab from "../tabs/table-tab";
import { DEF_PG_SIZE_SUB } from "../../constants/maximum-page-size";
interface Props {
    searchColumn: SearchTerm[];
    column: TableColumn[];
    id: string;
    dataMethod: (query?: ListQuery) => Promise<ListData>;
    children?: ReactNode;
    lookup: Lookup[];
}

const AssignTimeTriggeredAction: FC<Props> = ({
    searchColumn,
    column,
    id,
    dataMethod,
    children,
    lookup
}) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.assignedTimeTriggeredActions);
    const [filters, setFilters] = useState<Filter[]>([]);

    useEffect(() => {
        (() => {
            dataRefresh((query) => dataMethod(query));
        })();
    }, [id]);

    const [dataRefresh, setDataRefresh] = useState(
        () => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => {
            return;
        }
    );

    const manualDataRefresh = (
        refreshData: (
            dataMethod?: (query?: ListQuery) => Promise<ListData>
        ) => void
    ) => {
        setDataRefresh(() => refreshData);
    };

    return (
        <>
            <TableContextProvider
                dataMethod={dataMethod}
                manualDataRefresh={manualDataRefresh}
                tableDescriptor={column}
                searchDescriptor={searchColumn}
                useTable
                usePagination
                useSort
                useSearch
                useFilter
                maxPageSize={DEF_PG_SIZE_SUB}
                lookup={lookup}>
                <TableTab
                    title={title}
                    selectRows={false}
                    cyName="assignTimeTriggeredAction"
                >
                    {children}
                </TableTab>
            </TableContextProvider>
        </>
    );
};

export default AssignTimeTriggeredAction;
                  